<template>
  <ul>
    <li class="footer__title" v-if="label">{{ label }}</li>
    <template v-if="items && items.length > 0">
      <NavLink
        v-for="(item, index) of items"
        :key="`link__${index}`"
        :fields="item.fields"
        icon-type="dark"
      />
    </template>
  </ul>
</template>

<script setup>
const props = defineProps({
  fields: { type: Object, required: true },
  rendering: { type: Object, required: false },
});

const label = computed(() => props.fields?.label?.value);
const items = computed(() => props.fields?.items || []);
</script>
